<i18n>
{
	"en": {
		"bundleSupport": "EDI message bundle?"
	},
	"no":{
		"bundleSupport": "Bundling av edi meldinger?"
	}
}
</i18n>

<template>
	<div class="settings-grid">
		<ModifyCommonEdiPartSetting
			:ediSetup="edisetup"
			:messageMetadata="messageMetadata.outboundMessageMetadata"
			:transportMethods="messageMetadata.outboundTransportMethod"
		/>
		<t-switch v-if="bundleSupport" v-model="edisetup.enableBundling" :label="$t('bundleSupport')"/>
	</div>
</template>

<script>

import ModifyCommonEdiPartSetting from '../../ModifyCommonEdiPartSetting.vue';
export default {
	name: 'SetupDetails',
	components: { ModifyCommonEdiPartSetting },
	props: {
		messageMetadata: Object,
		edisetup: Object
	},

	computed: {
		bundleSupport() {
			let messageTypeMetadata = this.messageMetadata.outboundMessageMetadata.find(x => x.format === this.edisetup.messageType);
			let supportedFormat = messageTypeMetadata.supportedMessageFormats.find(x => x.format === this.edisetup.messageFormat);
			return supportedFormat.bundleSupport;
		}
	}
};
</script>

<style lang="scss" scoped>

.settings-grid{
	display: grid;
	row-gap: 5px;
}
</style>